import React from 'react';
import { motion } from 'framer-motion';
import { KeyIcon, ClockIcon, ZapOffIcon, MessageSquareIcon, AlertCircleIcon } from 'lucide-react';
const benefits = [{
  icon: <KeyIcon size={24} data-id="element-12" />,
  title: 'El fin de los rituales de pánico',
  description: 'Neutralizá el efecto de las llaves, los zapatos y el perfume.'
}, {
  icon: <ClockIcon size={24} data-id="element-13" />,
  title: 'El método de los 15 minutos de oro',
  description: 'Cómo superar el umbral donde ocurre el 90% de las crisis.'
}, {
  icon: <ZapOffIcon size={24} data-id="element-14" />,
  title: 'Tu perro "desenchufado"',
  description: 'Técnicas de relajación ambiental que realmente bajan el flujo de cortisol.'
}, {
  icon: <MessageSquareIcon size={24} data-id="element-15" />,
  title: 'Gestión de vecinos',
  description: 'Exactamente qué decir para ganar tiempo y evitar conflictos legales mientras aplicás el método.'
}, {
  icon: <AlertCircleIcon size={24} data-id="element-16" />,
  title: 'Guía de urgencia',
  description: 'Qué hacer hoy mismo si recibís una queja mientras estás en el trabajo.'
}];
export function Benefits() {
  return <section className="py-12 md:py-24 bg-cream-100" data-id="element-17">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="text-center mb-10 md:mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-20">
            Lo que vas a lograr con este manual
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-21">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-cream-200 hover:shadow-md transition-shadow" data-id="element-22">
              <div className="w-12 h-12 rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center mb-4 md:mb-6" data-id="element-23">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-24">
                {benefit.title}
              </h3>
              <p className="text-charcoal-light leading-relaxed" data-id="element-25">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}